/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "./headerUserConnected.scss";
import PropTypes from "prop-types";
import Modal from "Components/Modal/Modal";
import { updateAuth } from "Redux/Actions/authActions";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import image_profil from "assets/image_profil.webp";
import { FaAngleDown } from "react-icons/fa";
import { updateMenu } from "Redux/Actions/menuActions";
import { VscColorMode } from "react-icons/vsc";
import { useTranslation } from "react-i18next";
import GlobalSearch from "Components/GlobalSearch/GlobalSearch";
import { updateI18n } from "Redux/Actions/i18nActions";
import { logoutUser } from "Services/logout";

const headerUserConnected = (props) => {
  const [openConnexionInterface, setOpenConnexionInterface] = useState(false);
  const [openI18nInterface, setOpenI18nInterface] = useState(false);

  const [t, i18n] = useTranslation("common");

  // Déconnecte l'utilisateur : store vidé, cookie de session `t` supprimé, retour à l'accueil (RC-248)
  const disconnectUser = () => {
    logoutUser(props.handleAuth);
  };

  const [visibleModal, setVisibleModal] = useState(false);
  return (
      <div className="header__bandeau__userConnected">
        <div className="header__bandeau__userConnected__home">
          <button
              className="header__bandeau__userConnected__home__contraste"
              onClick={() => {
                props.handleAuth({
                  mode: props.auth.mode === "light" ? "dark" : "light",
                });
              }}
          >
            <VscColorMode />
          </button>
          <GlobalSearch></GlobalSearch>
          <div
              onMouseEnter={() => setOpenI18nInterface(true)}
              onMouseLeave={() => setOpenI18nInterface(false)}
          >
            <button className="header__bandeau__userDisconnected__home__language">
              {props.i18n.language.toUpperCase()}
            </button>
            {openI18nInterface && (
                <div className="connexionInterface language">
                  <ul>
                    <li
                        onClick={() => {
                          props.handleUpdateI18n({ language: "fr" }),
                              i18n.changeLanguage("fr");
                        }}
                    >
                      {t("header.language_fr")}
                    </li>
                    <li
                        onClick={() => {
                          props.handleUpdateI18n({ language: "en" }),
                              i18n.changeLanguage("en");
                        }}
                    >
                      {t("header.language_en")}
                    </li>
                  </ul>
                </div>
            )}
          </div>
        </div>
        <div className="userConnected__right__image_button">
          <button
              onMouseEnter={() => setOpenConnexionInterface(true)}
              onMouseLeave={() => setOpenConnexionInterface(false)}
              className="userConnectedButton"
          >
            {props.auth.isConnected && props.auth.userConnected && (
                <>
                  {props.auth.userConnected.firstname}
                </>
            )}

            <FaAngleDown />
            {openConnexionInterface && props.auth.userConnected && (
                <div
                    className="connexionInterfaceConnected"
                    onMouseEnter={() => setOpenConnexionInterface(true)}
                    onMouseLeave={() => setOpenConnexionInterface(false)}
                >
                  <ul>
                    <li>
                      {props.auth.isAdmin && "Admin"}
                      {props.auth.isAlumni && "Alumni"}
                      {props.auth.isPersonnel && "Personnel"}
                    </li>
                    <li
                        onClick={() => {
                          props.handleMenu({
                            activeItemProfil: props.items.itemsProfil.findIndex(
                                (v) => v.label == "Dernières offres d'emploi"
                            ),
                          });
                          window.location.pathname = "/profil";
                        }}
                    >
                      {t("footerApresConnexion.title_profil")}
                    </li>
                    <li onClick={() => disconnectUser()}>
                      {t("footerApresConnexion.logout")}
                    </li>
                  </ul>
                </div>
            )}
          </button>
          {visibleModal && (
              <Modal
                  visible={visibleModal}
                  setVisible={setVisibleModal}
                  header="Se connecter"
              >
                <form action="/action_page.php">
                  <label htmlFor="fname">First name:</label>
                  <input type="text" id="fname" name="fname" value="John" />
                  <label htmlFor="lname">Last name:</label>
                  <input type="text" id="lname" name="lname" value="Doe" />
                  <input type="submit" value="Submit" />
                </form>
              </Modal>
          )}
        </div>
      </div>
  );
};

headerUserConnected.propTypes = {
  auth: PropTypes.object,
  i18n: PropTypes.object,
  handleAuth: PropTypes.func,
  items: PropTypes.object,
  handleMenu: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  i18n: state.i18n,
});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
  handleUpdateI18n: (value) => {
    dispatch(updateI18n(value));
  },
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(headerUserConnected);
